export default __webpack_public_path__ + "static/media/Comprovante_STONEID.5c3a24d0.png";